<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="user icon"></i>
      {{ $t("staff") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/multimoney_staff.jpg"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="field">
            <label for="">{{ $t("associated modul user") }}</label>
            <user-search
              ref="user_search"
              @select_user="set_modul_user"
              @clear="clear_modul_user"
            />
          </div>
          <div class="ui dividing small header">
            <i class="info icon"></i> {{ $t("personal info") }}
          </div>
          <div class="fields">
            <div class="five wide field">
              <label for="">{{ $t("admission date") }}</label>
              <div class="ui calendar" ref="admission_date_calendar">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input
                    type="text"
                    name="admission_date"
                    v-model="admission_date"
                  />
                </div>
              </div>
            </div>
            <div class="five wide field">
              <label for="">{{ $t("status") }}</label>
              <div class="ui search selection dropdown" ref="status_dropdown">
                <div class="default text">{{ $t("select one") }}</div>
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div class="six wide field">
              <label for="">{{ $t("id number") }}</label>
              <input type="text" name="id_number" v-model="id_number" />
            </div>
          </div>
          <div class="four fields">
            <div class="field">
              <label for="">{{ $t("first name") }}</label>
              <input type="text" name="first_name" v-model="first_name" />
            </div>
            <div class="field">
              <label for="">{{ $t("second name") }}</label>
              <input type="text" name="second_name" v-model="second_name" />
            </div>
            <div class="field">
              <label for="">{{ $t("surname") }}</label>
              <input type="text" name="surname" v-model="surname" />
            </div>
            <div class="field">
              <label for="">{{ $t("second surname") }}</label>
              <input
                type="text"
                name="second_surname"
                v-model="second_surname"
              />
            </div>
          </div>
          <!-- <div class="two fields">
            <div class="field">
              <label for="">{{ $t("surname") }}</label>
              <input type="text" name="surname" v-model="surname" />
            </div>
            <div class="field">
              <label for="">{{ $t("second surname") }}</label>
              <input
                type="text"
                name="second_surname"
                v-model="second_surname"
              />
            </div>
          </div> -->
          <div class="two fields">
            <div class="field">
              <label for="">{{ $t("country") }}</label>
              <div class="ui search selection dropdown" ref="country_dropdown">
                <div class="default text">{{ $t("select one") }}</div>
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div class="field">
              <label for="">{{ $t("area") }}</label>
              <div class="ui search selection dropdown" ref="area_dropdown">
                <div class="default text">{{ $t("select one") }}</div>
                <i class="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div class="ui dividing small header">
            <i class="user icon"></i>{{ $t("users") }}
          </div>
          <div class="four fields">
            <div class="field">
              <label for="">{{ $t("ucontact") }}</label>
              <input type="text" name="ucontact_user" v-model="ucontact_user" />
            </div>
            <div class="field">
              <label for="">{{ $t("soc") }}</label>
              <input type="text" name="soc_user" v-model="soc_user" />
            </div>
            <!-- </div>
          <div class="two fields"> -->
            <div class="field">
              <label for="">{{ $t("core sys") }}</label>
              <input type="text" name="core_sys_user" v-model="core_sys_user" />
            </div>
            <div class="field">
              <label for="">{{ $t("printing") }}</label>
              <input type="text" name="printing_user" v-model="printing_user" />
            </div>
          </div>
          <div class="ui dividing small header">
            <i class="users icon"></i>{{ $t("team") }}
          </div>
          <div class="three fields">
            <div class="field">
              <label for="">{{ $t("job position") }}</label>
              <div
                class="ui search selection dropdown"
                ref="job_position_dropdown"
              >
                <div class="default text">{{ $t("select one") }}</div>
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div class="field">
              <label for="">{{ $t("team") }}</label>
              <div class="ui search selection dropdown" ref="team_dropdown">
                <div class="default text">{{ $t("select one") }}</div>
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div class="field">
              <label for="">{{ $t("grouper") }}</label>
              <div class="ui search selection dropdown" ref="grouper_dropdown">
                <div class="default text">{{ $t("select one") }}</div>
                <i class="dropdown icon"></i>
              </div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("immediate superior") }}</label>
            <staff-search
              ref="immediate_superior_search"
              @selected="set_immediate_superior"
              @clear="clear_immediate_superior"
            />
          </div>
          <!-- <h5 class="ui dividing header">
            <i class="small sitemap icon"></i> {{ $t("hierarchy") }}
          </h5>
          <div class="ui relaxed divided list">
            <div class="item" v-for="(h, hidx) in hierarchy" :key="hidx">
              <i class="user tie middle aligned icon"></i>
              <div class="content">
                <a class="header">{{ h.name }}</a>
                <div class="description">{{ h.description }}</div>
              </div>
            </div>
          </div> -->
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui left floated red icon right labeled button"
        v-if="uuid"
        @click="remove"
      >
        <i class="trash icon"></i>
        {{ $t("delete") }}
      </div>
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui blue icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import UserSearch from "@/components/UserSearch";
import StaffSearch from "./StaffSearch";
// import GenericContainer from "@/components/GenericContainer";

export default {
  name: "MultimoneyStaffStaffModalIndex",
  components: {
    UserSearch,
    StaffSearch,
  },
  props: {},
  computed: {},
  data() {
    return {
      uuid: "",
      modul_user_id: "",
      admission_date: "",
      id_number: "",
      first_name: "",
      second_name: "",
      surname: "",
      second_surname: "",
      ucontact_user: "",
      soc_user: "",
      core_sys_user: "",
      printing_user: "",
      status_id: "",
      country_id: "",
      area_id: "",
      job_position_id: "",
      team_id: "",
      grouper_id: "",
      // hierarchy: [],
      immediate_superior_id: "",
      // form: undefined,
      catalogs: {},
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        local_api(vm, "post", "/multimoney_staff/admin/do-get-staff", {
          u: data,
        })
          .then((staff_data) => {
            Object.keys(staff_data).map((k) => {
              if (k == "user_id") {
                vm.modul_user_id = staff_data[k];
                if (vm.$refs.user_search && staff_data[k])
                  vm.$refs.user_search.set_user(staff_data[k]);
              } else if (k == "immediate_superior_staff_id") {
                vm.immediate_superior_id = staff_data[k];
                if (vm.$refs.immediate_superior_search && staff_data[k])
                  vm.$refs.immediate_superior_search.set_staff(staff_data[k]);
              } else vm[k] = staff_data[k];
            });
          })
          .catch((err) => {
            error_toast(err);
          });
        // console.log(data);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            vm.init_dropdowns();
            setTimeout(() => {
              window.jQuery(vm.$refs.admission_date_calendar).calendar({
                type: "date",
                onChange(value) {
                  vm.admission_date = value;
                },
              });

              if (vm.status_id)
                window
                  .jQuery(vm.$refs.status_dropdown)
                  .dropdown("set selected", vm.status_id);
              if (vm.country_id)
                window
                  .jQuery(vm.$refs.country_dropdown)
                  .dropdown("set selected", vm.country_id);
              if (vm.area_id)
                window
                  .jQuery(vm.$refs.area_dropdown)
                  .dropdown("set selected", vm.area_id);
              if (vm.job_position_id)
                window
                  .jQuery(vm.$refs.job_position_dropdown)
                  .dropdown("set selected", vm.job_position_id);
              if (vm.team_id)
                window
                  .jQuery(vm.$refs.team_dropdown)
                  .dropdown("set selected", vm.team_id);
              if (vm.grouper_id)
                window
                  .jQuery(vm.$refs.grouper_dropdown)
                  .dropdown("set selected", vm.grouper_id);
              if (vm.immediate_superior_id)
                window
                  .jQuery(vm.$refs.immediate_superior_dropdown)
                  .dropdown("set selected", vm.immediate_superior_id);
            }, 200);
          },
          onHidden() {
            vm.form.form("reset");
            if (vm.$refs.user_search) vm.$refs.user_search.clean();
            if (vm.$refs.immediate_superior_search)
              vm.$refs.immediate_superior_search.clean();

            vm.uuid = "";
            vm.modul_user_id = "";
            vm.admission_date = "";
            vm.id_number = "";
            vm.first_name = "";
            vm.second_name = "";
            vm.surname = "";
            vm.second_surname = "";
            vm.ucontact_user = "";
            vm.soc_user = "";
            vm.core_sys_user = "";
            vm.printing_user = "";

            vm.status_id = "";
            vm.country_id = "";
            vm.area_id = "";
            vm.job_position_id = "";
            vm.team_id = "";
            vm.grouper_id = "";
            vm.immediate_superior_id = "";

            window.jQuery(vm.$refs.status_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.country_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.area_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.job_position_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.team_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.grouper_dropdown).dropdown("clear");
            window
              .jQuery(vm.$refs.immediate_superior_dropdown)
              .dropdown("clear");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          id_number: ["empty"],
          first_name: ["empty"],
          surname: ["empty"],
          ucontact_user: ["empty"],
          soc_user: ["empty"],
          core_sys_user: ["empty"],
          printing_user: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/multimoney_staff/admin/do-save", {
          u: vm.uuid,
          mi: vm.modul_user_id,
          a: vm.admission_date,
          i: vm.id_number,
          fn: vm.first_name,
          sn: vm.second_name,
          sr: vm.surname,
          ss: vm.second_surname,
          uu: vm.ucontact_user,
          su: vm.soc_user,
          cu: vm.core_sys_user,
          pu: vm.printing_user,
          s: vm.status_id,
          ct: vm.country_id,
          ar: vm.area_id,
          jp: vm.job_position_id,
          tm: vm.team_id,
          gp: vm.grouper_id,
          is: vm.immediate_superior_id,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    add_field() {
      let vm = this;
      vm.fields.push({
        name: "",
        path: "",
      });
    },
    set_modul_user(user) {
      let vm = this;
      vm.modul_user_id = user.user_id;
    },
    clear_modul_user() {
      let vm = this;
      vm.modul_user_id = "";
    },
    set_immediate_superior(user) {
      let vm = this;
      vm.immediate_superior_id = user.staff_id;
    },
    clear_immediate_superior() {
      let vm = this;
      vm.immediate_superior_id = "";
    },
    init_dropdowns() {
      let vm = this;
      // Set areas
      if (vm.catalogs.areas) {
        let vls = vm.catalogs.areas
          .map((itm) => {
            return { name: itm.name, value: itm.area_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.area_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.area_id = value;
            },
          });
      }

      // Countries
      if (vm.catalogs.countries) {
        let vls = vm.catalogs.countries
          .map((itm) => {
            return { name: itm.name, value: itm.country_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.country_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.country_id = value;
            },
          });
      }

      // Groupers
      if (vm.catalogs.groupers) {
        let vls = vm.catalogs.groupers
          .map((itm) => {
            return { name: itm.name, value: itm.grouper_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.grouper_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.grouper_id = value;
            },
          });
      }

      // Job positions
      if (vm.catalogs.job_position) {
        let vls = vm.catalogs.job_position
          .map((itm) => {
            return { name: itm.name, value: itm.job_position_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.job_position_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.job_position_id = value;
            },
          });
      }

      // Status
      if (vm.catalogs.status) {
        let vls = vm.catalogs.status
          .map((itm) => {
            return { name: itm.name, value: itm.status_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.status_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.status_id = value;
            },
          });
      }

      // Teams
      if (vm.catalogs.teams) {
        let vls = vm.catalogs.teams
          .map((itm) => {
            return { name: itm.name, value: itm.team_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.team_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.team_id = value;
            },
          });
      }

      // Immediate superior
      if (vm.catalogs.groupers) {
        let vls = vm.catalogs.groupers
          .map((itm) => {
            return { name: itm.name, value: itm.grouper_id };
          })
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            return 0;
          });
        window
          .jQuery(vm.$refs.grouper_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.grouper_id = value;
            },
          });
      }
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove staff?"), function () {
        local_api(vm, "post", "/multimoney_staff/admin/do-remove", {
          u: vm.uuid,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/multimoney_staff/admin/do-get-catalogs", {})
      .then((catalogs) => {
        if (catalogs) {
          vm.catalogs = catalogs;
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
  updated: function () {},
};
</script>
